export default __webpack_public_path__ + "static/177-891a70606a1eca5ec9c7b12710e06949.gif";